import { IRows, IColumns } from '../../atoms/Table/Table';
import { DateTypography } from '../../molecules/ExhibitTableDateTypography';

interface AllocationExhibit {
    startingYear: number;
    retirementYear?: number;
    equity: number[];
    fixedIncome: number[];
    cash: number[];
    t: any;
}

export const getAllocationsExhibitTableData = ({
    startingYear,
    retirementYear,
    equity,
    cash,
    fixedIncome,
    t
}: AllocationExhibit) => {
    const exhibitColumns: IColumns[] = [
        { name: t('DATE_TEXT'), width: '40%', alignment: 'left' },
        { name: t('EQUITY'), alignment: 'right' },
        { name: t('FIXED INCOME'), alignment: 'right' },
        { name: t('CASH'), alignment: 'right' }
    ];

    const formatRows = (year: number, index: number, isRetirement = false): React.ReactNode[] | string[] => {
        return [
            <DateTypography key={`date-${year}`} label={year} isRetirement={isRetirement} />,
            `${equity[index] ?? 0}%`,
            `${fixedIncome[index] ?? 0}%`,
            `${cash[index] ?? 0}%`
        ];
    };

    // building the rows
    const exhibitRows: IRows[] = [];
    exhibitRows.push({ id: 'starting-year', values: formatRows(startingYear, 0) });

    if (retirementYear) {
        const retirementIndex = retirementYear - startingYear;
        exhibitRows.push({ id: 'retirement-year', values: formatRows(retirementYear, retirementIndex, true) });
    }
    const lastYearIndex = equity.length - 1;
    const lastYear = startingYear + lastYearIndex;
    exhibitRows.push({ id: 'ending-year', values: formatRows(lastYear, lastYearIndex) });

    return { exhibitColumns, exhibitRows };
};
